/**
 * Periodically animates the add to cart buttons to draw the customer's eye.
 *
 * Buttons opt in with data-atc-attention="{seconds between animations}" and an
 * .atc-attention--{style} class. Elements are re-queried on every tick, so
 * buttons that get re-rendered on a variant change keep animating.
 */
(() => {
  const SELECTOR = '[data-atc-attention]';
  const ANIMATE_CLASS = 'atc-attention--animate';
  const MIN_INTERVAL = 2;

  // The script lives inside the product section, so it re-runs whenever the
  // theme editor re-renders it. Only ever run one timer.
  if (window.themeAtcAttention) return;
  window.themeAtcAttention = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /**
   * @param {Element} el
   * @returns {boolean} Whether the element is on screen and worth animating.
   */
  function isAnimatable(el) {
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
    if (el.closest('[hidden], .sticky-atc-panel--out')) return false;

    const rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (rect.bottom <= 0 || rect.top >= (window.innerHeight || document.documentElement.clientHeight)) return false;

    return getComputedStyle(el).visibility !== 'hidden';
  }

  function animate() {
    if (document.hidden) return;

    document.querySelectorAll(SELECTOR).forEach((el) => {
      if (el.classList.contains(ANIMATE_CLASS) || !isAnimatable(el)) return;

      el.addEventListener('animationend', () => el.classList.remove(ANIMATE_CLASS), { once: true });
      el.classList.add(ANIMATE_CLASS);
    });
  }

  function init() {
    const el = document.querySelector(SELECTOR);
    if (!el) return;

    const seconds = Math.max(MIN_INTERVAL, parseFloat(el.dataset.atcAttention) || 6);
    setInterval(animate, seconds * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
